const SITE_BASE_URL = "https://nysacentraltexas.com/admin/api/";
export const API_URL = {
    SITE_SETTING: `${SITE_BASE_URL}siteSetting`,
    LOGIN: `${SITE_BASE_URL}login`,
    ME: `${SITE_BASE_URL}me`,
    PROPERTY: `${SITE_BASE_URL}property`,
    INQUIRY: `${SITE_BASE_URL}inquiry`,
    CONTACT: `${SITE_BASE_URL}contact_us`,
    PROFILE_PICTURE: `${SITE_BASE_URL}profile_picture`,
    CHANGE_PASSWORD: `${SITE_BASE_URL}change_password`,
    UPDATE_PROFILE: `${SITE_BASE_URL}profile_update`,
    FEATURE_PROPERTY: `${SITE_BASE_URL}featureProperty`,
    FORGOT_PASSWORD: `${SITE_BASE_URL}forgotPassword`,
    RESET_PASSWORD: `${SITE_BASE_URL}resetPassword`,
    CMS: {
        HOME: `${SITE_BASE_URL}cms/home`,
        ABOUTUS: `${SITE_BASE_URL}cms/aboutUs`,
    },
};
